import React, { forwardRef, useRef, useState } from 'react';
// import PropTypes from 'prop-types';
import cn from 'classnames';

import { phoneDetect, tabletDetect } from 'redhotpie-shared-lib/functions/utils';
import './styles.scss';

interface ImgProps {
  className?: string;
  alt?: string;
  src?: string;
  onClick?: (e: React.MouseEvent) => void;
  onLoad?: () => void;
  onError?: () => void;
  width?: number;
  height?: number;
  id?: string;
  style?: object;
}

const Img = forwardRef((props: ImgProps, ref: any) => {
  const refCurrImg = useRef<HTMLImageElement>(null);
  const { onLoad, onError, src, ...anotherProp } = props;
  const [showSkeleton, setShowSkeleton] = useState(false);

  const isMobile = phoneDetect();
  const isTablet = tabletDetect();

  function onLoaded() {
    if (typeof onLoad === 'function') {
      onLoad();
    }
    setShowSkeleton(false);
  }

  function onErrored() {
    if (typeof onError === 'function') {
      onError();
    }
    setShowSkeleton(true);
  }

  const isDesktop = !isMobile && !isTablet;

  return (
    // eslint-disable-next-line ,
    <img
      className={cn({
        [props.className || '']: props.className,
        'skeleton-img': showSkeleton,
      })}
      alt={props.alt}
      src={src}
      onClick={props.onClick}
      ref={ref || refCurrImg}
      id={props.id}
      onLoad={onLoad}
      onError={onError}
      {...anotherProp}
      draggable="false"
    />
  );
});

export default Img;
